<template>
  <div>
    <Title :title="'换电订单数量及负荷率'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { siteLeft } from '@/api/singleSite/left';
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[],
        yAxis:[
          {
            splitLine: { 
                show: true,
                lineStyle: {
                  color: ["rgba(255, 255, 255, 0.15)"]
                }
              },
              splitNumber: 3, // 横线数
              axisLine: {
                show:false
              },
              // position:'30%',
              axisLabel: {
                formatter: "{value} ",
                textStyle: {
                  color: "rgba(255, 255, 255, 0.65)",
                  fontSize:16
                }
              },  
            name: '换电订单数量（次）',
            nameLocation:'end',
            type: 'value'
          },
          {
            splitLine: { 
                show: true,
                lineStyle: {
                  color: ["rgba(255, 255, 255, 0.15)"]
                }
              },
              splitNumber: 2, // 横线数
              axisLine: {
                show:false
              },
              position:'right',
              axisLabel: {
                formatter: "{value} ",
                textStyle: {
                  color: "rgba(255, 255, 255, 0.65)",
                  fontSize:16
                }
              },  
            name: '负荷率（%）',
            type: 'value',
          }
        ],
        series:[
            {
              name: "换电订单数量",
              type: "line",
              smooth: true,
              center:['50%','50%'],
              symbolSize: 1,
              // yAxisIndex: 1,
              itemStyle: {
                color: "#90F3FF" 
              },
              areaStyle: {
                color:new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#00FFFF" },
                    { offset: 1, color: "#010D44" }
                ]),
                opacity: 0.5
              },
              data: [0, 0, 0, 0, 0, 0,0, 0, 0, 0]
            },
            {
              name: "负荷率",
              type: "bar",
              center:['50%','50%'],
              barWidth: 10,
              yAxisIndex: 1,
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36A1FF" },
                    { offset: 1, color: "#1968FF" }
                  ])
                }
              },
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
        ]
      },
      style:{
        width: '500',
        height: '180'
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {

  },
  methods: {
    getData(data){
      this.selectStationBatteryAndLoadRate(data);
    },
    selectStationBatteryAndLoadRate(data={}){
      let _this = this;
      let params = {
        '@station_id':data.stationId,
        "enCode":"TiDB-zhandian-dianchixuqiujihefuhelv"
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let x = [];
          let y1 = [];//电池配置
          let y2=[];//负荷率
          res.forEach(item=>{
            x.push(item.hour_num);
            y2.push(item.station_rate);
            y1.push(item.frequency);
          })
          this.cdata.series[0].data = y1;
          this.cdata.series[1].data = y2;
          this.cdata.category = x;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>